import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedSettings } from '../models/shared-settings';
import { url } from '../helpers/url';
import { HistoryResponse } from '../models/history';
import { DateTime } from 'luxon';


@Injectable({
    providedIn: 'root'
})

export class HistoryService {

    constructor(private http: HttpClient, private settings: SharedSettings) { }

    getHistory(siteId: string, entityId: number, entityType: string): Observable<HistoryResponse[]> {
        return this.http.get<HistoryResponse[]>(this.settings.apiBaseUrl + url`admin/history?siteId=${siteId}&entityId=${entityId}&entityType=${entityType}`).pipe(tap(history => history.forEach(h => {
            this.fixDates(h);
        })));
    }

    getInboundLoadHistory(siteId: string, entityId: number): Observable<HistoryResponse[]> {
        return this.http.get<HistoryResponse[]>(this.settings.apiBaseUrl + url`admin/history/inbound-loads/?siteId=${siteId}&entityId=${entityId}`).pipe(tap(history => history.forEach(h => {
            this.fixDates(h);
        })));
    }

    getOutboundLoadHistory(siteId: string, entityId: number): Observable<HistoryResponse[]> {
        return this.http.get<HistoryResponse[]>(this.settings.apiBaseUrl + url`admin/history/outbound-loads/?siteId=${siteId}&entityId=${entityId}`).pipe(tap(history => history.forEach(h => {
            this.fixDates(h);
        })));
    }
    
    private fixDates(history: HistoryResponse): void {
        history.timestamp = !!history.timestamp ? DateTime.fromISO(history.timestamp.toString()) : history.timestamp;
    }
}
